<template>
	<div class="card card-user-activity">
		<a :href="itemLink" class="card-media" v-if="item.entity.preview">
			<img class="card-media-image" :src="item.entity.preview">
		</a>
		<div class="card-content">
			You {{ item.action }} <a :href="itemLink">{{ item.entity.title }}</a>
			<div class="card-info flex flex-col sm:flex-row justify-start">
				<i>{{ item.timestampFormatted }}</i>
				<div v-if="!!item.entity.total_hands_on" class="card-info-hands-on">Hands-on: {{ item.entity.total_hands_on }}</div>
			</div>
		</div>
	</div>
</template>

<script>
		import ListItem from '../mixins/base-list-item';

		export default{
			mixins: [ListItem],

				computed: {
					itemLink() {
						if(this.item.entity.model_code) {
							return '/' + this.item.entity.model_code + 's/' + this.item.entity.slug;
						} else {
							return '/lessons/' + this.item.entity.slug;
						}
					}
				}
		}
</script>
